import { SaveButton } from "components/Buttons"
import React from "react"
import { Col, Container, Row } from "reactstrap"

const OrderCheckout = ({ orderCheckoutSession }) => {
  return (
    <React.Fragment>
      <Container fluid className="col-lg-6 p-3">
        <Row className="d-flex justify-content-center text-center">
          <Col xs="auto">
            <h5>
              If the checkout screen doesn't pop up, click the button below.
            </h5>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center my-2">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="CHECKOUT"
              onClick={() => {
                window.open(orderCheckoutSession?.url)
              }}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-3 text-center">
          <Col xs="auto">
            <p>
              You will receive an email after the payment is complete. (If you
              don't receive the email, please check SPAM and make sure your
              email is not blocking info@westernedge.com)
            </p>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default OrderCheckout
